import React from 'react';
import CompanyEntriesContainer from './CompanyEntriesContainer';
const CompanyTagsPage = () => React.createElement(CompanyEntriesContainer, null);
export default CompanyTagsPage;
